<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card card-form">
          <div class="card-header">
            <div class="row">
              <div class="col">
                <div class="pull-left">
                  <h4 class="card-title float-left">
                    {{ $t("auto.plus.list") }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 scrollable-div-auto">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>{{ $t("auto.selectAuto") }} <span class="red">*</span></label>
                      <v-select v-model="autoData.autoTypeDto"
                                label="fullName"
                                :options="autoTypeDtos"
                                :filterable="false"
                                @search="onAutoTypeSearch"
                                @search:focus="onAutoTypeFocus"
                                :class="{invalid : $v.autoData.autoTypeDto.$error}">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.text"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="autoData.autoTypeDto && autoData.autoTypeDto.text">
                          <div v-html="autoData.autoTypeDto.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>

                      <div class="red" v-if="$v.autoData.autoTypeDto.$error">
                        {{ $t("auto.selectAuto") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.madeYear") }} <span class="red">*</span></label>
                      <numeric-input class="form-control"
                                     v-model="autoData.madeYear"
                                     :class="{invalid : $v.autoData.madeYear.$error}"
                                     :controls="false" :precision="0"></numeric-input>
                      <div class="red" v-if="$v.autoData.madeYear.$error">
                        {{ $t("auto.madeYear") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.governmentNum") }} <span
                          class="red">*</span></label>
                      <input type="text" class="form-control"
                             v-model="autoData.governmentNum"
                             :class="{invalid : $v.autoData.governmentNum.$error}"/>
                      <div class="red"
                           v-if="$v.autoData.governmentNum.$error">
                        {{ $t("auto.governmentNum") }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{ $t("auto.engineNum") }} </label>
                      <input type="text" class="form-control"
                             v-model="autoData.engineNum"/>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.bodyNum") }} </label>
                      <input type="text" class="form-control"
                             v-model="autoData.bodyNum"/>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.shasseNum") }} </label>
                      <input type="text" class="form-control"
                             v-model="autoData.shasseNum"/>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.autoColor") }} </label>
                      <input type="text" class="form-control"
                             v-model="autoData.autoColor"/>
                    </div>


                    <div class="form-group">
                      <label>{{ $t("auto.fullWeight") }} </label>
                      <input type="text" class="form-control"
                             v-model="autoData.fullWeight"/>
                    </div>
                    <div class="form-group">
                      <label>{{ $t("auto.highWeight") }} </label>
                      <input type="text" class="form-control"
                             v-model="autoData.highWeight"/>
                    </div>
                    <div class="form-group">
                      <label>{{ $t("auto.texPassportNum") }} <span
                          class="red">*</span></label>
                      <input type="text" class="form-control"
                             v-model="autoData.texPassportNum"
                             :class="{invalid : $v.autoData.texPassportNum.$error}"/>
                      <div class="red"
                           v-if="$v.autoData.texPassportNum.$error">
                        {{ $t("auto.texPassportNum") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.adress") }} <span class="red">*</span></label>
                      <input type="text" class="form-control"
                             v-model="autoData.address"
                             :class="{invalid : $v.autoData.address.$error}"/>
                      <div class="red" v-if="$v.autoData.address.$error">
                        {{ $t("auto.adress") }}
                      </div>
                    </div>


                    <div class="form-group"
                         v-if="hasNotMileage">
                      <label>{{ $t("auto.overpassKm") }} <span class="red">*</span></label>
                      <numeric-input class="form-control" v-model="autoData.overpassKm"
                                     :class="{invalid : $v.autoData.overpassKm.$error}"
                                     :controls="false" :precision="0"></numeric-input>
                      <div class="red" v-if="$v.autoData.overpassKm.$error">
                        {{ $t("auto.overpassKm") }}
                      </div>
                    </div>

                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>{{ $t("auto.technicalConditionReport") }} </label>
                      <select class="form-control"
                              v-model="autoData.technicalConditionReport"
                              @change="onChangeTechnicalConditionReport">
                        <option value=""></option>
                        <option :value="option.key"
                                v-for="option in technicalConditions" :key="option.id">
                          {{ option.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.electricalComponents") }} </label>
                      <select class="form-control"
                              v-model="autoData.electricalComponents">
                        <option value=""></option>
                        <option :value="option.key" v-for="option in autoPartConditions"
                                :key="option.key">
                          {{ option.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.steeringMechanisms") }} </label>
                      <select class="form-control"
                              v-model="autoData.steeringMechanisms">
                        <option value=""></option>
                        <option :value="option.key" v-for="option in autoPartConditions"
                                :key="option.id">
                          {{ option.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.engine") }} </label>
                      <select class="form-control" v-model="autoData.engine">
                        <option value=""></option>
                        <option :value="option.key" v-for="option in autoPartConditions"
                                :key="option.id">
                          {{ option.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.transmissionBox") }} </label>
                      <select class="form-control"
                              v-model="autoData.transmissionBox">
                        <option value=""></option>
                        <option :value="option.key" v-for="option in autoPartConditions"
                                :key="option.id">
                          {{ option.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.saloonParts") }} </label>
                      <select class="form-control"
                              v-model="autoData.saloonParts">
                        <option value=""></option>
                        <option :value="option.key"
                                v-for="option in evlAutoSaloonPartConditions"
                                :key="option.id">
                          {{ option.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.additionalConveniences") }} </label>
                      <select class="form-control"
                              v-model="autoData.additionalConveniences">
                        <option value=""></option>
                        <option :value="option.key"
                                v-for="option in additionalConveniences"
                                :key="option.key">
                          {{ option.name }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>Ёқилғи тури <span class="red">*</span></label>
                      <select class="form-control"
                              v-model="autoData.fuelType">
                        <option :value="option.key" v-for="option in fuelTypes"
                                :key="option.key">{{ option.name }}
                        </option>
                      </select>
                      <div class="red"
                           v-if="$v.autoData.fuelType.$error">
                        Ёқилғи тури
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.technicalConditionOfCar") }} <span class="red">*</span></label>
                      <select class="form-control"
                              v-model="autoData.technicalConditionOfCar"
                              :class="{invalid : $v.autoData.technicalConditionOfCar.$error}"
                              @change="onChangeTechnicalCondition">
                        <option value=""></option>
                        <option value=""></option>
                        <option :value="option.key"
                                v-for="option in technicalConditionOfCars"
                                :key="option.key">
                          {{ option.name }}
                        </option>
                      </select>
                      <div class="red"
                           v-if="$v.autoData.technicalConditionOfCar.$error">
                        {{ $t("auto.technicalConditionOfCar") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("auto.dilapidationValueByExpert") }} <span
                          class="red">*</span></label>
                      <select class="form-control"
                              v-model="autoData.dilapidationValueByExpert"
                              :class="{invalid : $v.autoData.dilapidationValueByExpert.$error}">
                        <option value=""></option>
                        <option :value="option.key" v-for="option in dilapidationLookupData"
                                :key="option.key">
                          {{ option.name }}
                        </option>
                      </select>
                      <div class="red"
                           v-if="$v.autoData.dilapidationValueByExpert.$error">
                        {{ $t("auto.dilapidationValueByExpert") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                      v-model="selectedRealEstateDocsTab"
                      :options="[
                                { text: 'Автотранспорт расмлари', value: 'images' },
                                { text: 'Хужжатлар', value: 'docs' } ]"
                      :aria-describedby="ariaDescribedby"
                      button-variant="form-radio-group"
                      name="radio-btn-outline1"
                      buttons
                  ></b-form-radio-group>
                </b-form-group>

                <div v-if="selectedRealEstateDocsTab === 'images'" class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in autoAllPhotos" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <!--<img :src="photo.filePath" width="100%" style="height: 500px;" :style="rotateStyle" />-->
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>

                <div v-if="selectedRealEstateDocsTab === 'docs'" class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in texPassportAllPhotos" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <!--<img :src="photo.filePath" width="100%" style="height: 500px;" :style="rotateStyle" />-->
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>
              </div>
              <div class="col-12">
                <button class="all-btn add-btn pull-left" @click="saveAuto">
                  {{ $t("action.save") }}
                </button>
              </div>

            </div>


            <div role="tablist">
              <!--              <div class="row">-->
              <!--                <div class="col-12">-->
              <!--                  <div class="section-header font-weight-bold colllapse-header">-->
              <!--                    <div block v-b-toggle.header-1 v-tooltip="'Автотранспорт маълумотлари'">-->
              <!--                      <h4>-->
              <!--                        <i class="fa fa-arrow-down"></i>-->
              <!--                        {{ $t("auto.plus.autoInformationVisible") }}-->
              <!--                      </h4>-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                  <b-collapse id="header-1" accordion="evl-accordion" role="tabpanel"-->
              <!--                              v-model="autoInformationVisible">-->
              <!--                    <div class="row">-->
              <!--                      <div class="col-12 col-lg-4 col-md-6">-->

              <!--                      </div>-->
              <!--                      <div class="col-12 col-lg-4 col-md-6">-->


              <!--                      </div>-->
              <!--                      <div class="col-12 col-lg-4 col-md-6">-->


              <!--                      </div>-->
              <!--                    </div>-->
              <!--                  </b-collapse>-->
              <!--                </div>-->
              <!--              </div>-->

              <div class="row">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.auto-comparative v-tooltip="'Қиёсий ёндашув'">
                      <h4>
                        <div class="d-flex">
                          <i class="fa fa-arrow-down"></i>
                          <input type="checkbox" class="ml-2 mr-1"
                                 v-model="autoData.approachThree">
                          {{ $t("auto.approach.comparative") }}
                          <b class="ml-4" v-if="autoData.approachThree">
                            <span class="text-success"
                                  v-if="autoData.kossApiResponseDto && autoData.kossApiResponseDto.govPrice">{{
                                autoData.kossApiResponseDto.govPrice | currency('', 2, {thousandsSeparator: ' '})
                              }} сўм</span>
                            <span class="text-success"
                                  v-else>{{ 0 | currency('', 2, {thousandsSeparator: ' '}) }} сўм</span>
                          </b>
                        </div>

                      </h4>
                    </div>
                  </div>
                  <b-collapse id="auto-comparative" accordion="evl-accordion" role="tabpanel">
                    <div class="row">
                      <div class="col-12">
                        <div class="card card-form">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-12" style="min-height: 500px">
                                <div class="table-wrapper">
                                  <table class="table table-bordered"
                                         v-if="autoData.kossApiResponseDto && autoData.kossApiResponseDto.autoDataApiList && autoData.kossApiResponseDto.autoDataApiList.length > 0">

                                    <tr>
                                      <td align="center" class="align-middle"><b><i>№</i></b></td>
                                      <td align="center" class="align-middle"><b><i>Кўрсаткичлар</i></b>
                                      </td>
                                      <td align="center" class="align-middle"><b><i>Тузатиш
                                        элементлари</i></b></td>
                                      <td align="center" class="align-middle"><b><i>Баҳолаш объекти</i></b>
                                      </td>
                                      <td colspan="3" align="center"><b><i>Такослаш объекти (аналоги)</i></b></td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center"><b><i>I. Бўлим: Бозорни тадкик килиш, аналог
                                        обектлар бўйича ахборотни тахлил килиш ва йиғиш</i></b></td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center"><b><i>1,1 Аналог объектларга доир битимлар
                                        (таклифлар) тўғрисида ахборот олиш максадида тадкик килиш.</i></b></td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,1</i></b></td>
                                      <td align="center"><b><i>Аналоглар</i></b></td>
                                      <td></td>
                                      <td></td>
                                      <td align="center"><b><i>Анолог 1</i></b></td>
                                      <td align="center"><b><i>Анолог 2</i></b></td>
                                      <td align="center"><b><i>Анолог 3</i></b></td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,2</i></b></td>
                                      <td align="center"><b><i>Русуми</i></b></td>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        {{ autoData.name }}
                                      </td>
                                      <td align="center" class="align-middle font-weight-bold" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].name }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,3</i></b></td>
                                      <td align="center" class="font-weight-bold">Позицияси</td>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        {{
                                          autoData.autoTypeDto && autoData.autoTypeDto.position ? autoData.autoTypeDto.position : ''
                                        }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].position }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,4</i></b></td>
                                      <td align="center" class="font-weight-bold">Ишлаб чиқарилган йили</td>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        {{ autoData.madeYear }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{ autoData.kossApiResponseDto.autoDataApiList[n - 1].productionYear }}</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="2"
                                          class="align-middle font-weight-bold"><b><i>1,1,5</i></b>
                                      </td>
                                      <td align="center" rowspan="2"
                                          class="align-middle font-weight-bold">Маълумотлар баъзасида
                                        сакланаган ва Фойдаланилган манба
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].foreignCar
                                              ? "Хорижий" : "Махалий"
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].source }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,6</i></b></td>
                                      <td align="center" class="font-weight-bold">Маълумотлар баъзасидаги
                                        Манбанинг эълон рақами ва хаволаси
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].link }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,1,7</i></b></td>
                                      <td align="center" class="font-weight-bold">Сотишга таклиф қилинган ёки
                                        сотилган сана
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].sourceDate }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            1,2 Аналог объектларга доир битимлар (таклифлар) тўғрисида
                                            ахборот олиш максадида тахлил килиш.
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" class="align-middle"><b><i>1,2,1</i></b></td>
                                      <td align="center" class="font-weight-bold">Сотишга таклиф қилинган ёки
                                        сотилган санадаги АҚШ долларини ўзбек сўмига нисбатан курси Марказий
                                        банк эълон ставкасида
                                      </td>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        <b>{{
                                            autoData.kossApiResponseDto.usdRate | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                      <td align="center" class="align-middle"
                                          v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].usdRate | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,2,2</i></b></td>
                                      <td align="center" class="font-weight-bold">
                                        Сотишга таклиф қилинган ёки сотилган санага нисбатан, Сотилиш баҳоси.
                                        АҚШ долларида
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" class="align-middle"
                                          v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].usdPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          $</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b><i>1,2,3</i></b></td>
                                      <td align="center" class="font-weight-bold">Сотишга таклиф қилинган ёки
                                        сотилган санага нисбатан Сотилиш бахоси.
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].uzsPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="2" class="align-middle">
                                        <b><i>1,2,4</i></b></td>
                                      <td align="center" rowspan="2" class="align-middle font-weight-bold">Шартномавий
                                        нархи
                                      </td>
                                      <td align="center">Транспорт харажати</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].transportation.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Шартномавий нархи</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].transportation.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="6" class="align-middle">
                                        <b><i>1,2,5</i></b></td>
                                      <td align="center" rowspan="5" class="align-middle font-weight-bold">Импорт
                                        килишда
                                        соликлар ва йигимлар
                                      </td>
                                      <td align="center">Божхона божи</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.customs }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Акциз</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.excise }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">ҚҚС</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.vat }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Божхона харажатлари</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.customsClearance }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.taxCoefficient }}
                                        %
                                      </td>
                                    </tr>
                                    <tr align="center" class="align-middle">
                                      <td><b><i>Таклиф ёки сотилиш нархи</i></b></td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].taxDto.taxFixPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2-Бўлим:Киёслаш бирликларини аниклаш
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2,1 Техник тавсифлар
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,1</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">Унумдорлиги
                                        ёки
                                        куввати (Двигател ҳажмига тузатиш)
                                      </td>
                                      <td align="center">Дивигател хажми</td>
                                      <td rowspan="3" align="center" class="align-middle">
                                        {{
                                          autoData.autoTypeDto &&
                                          autoData.autoTypeDto.engineCapacity ?
                                              autoData.autoTypeDto.engineCapacity : ''
                                        }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.value }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,2</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Юк кўтариши
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,3</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Юк тортиши
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,4</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Иш макони хажимлари
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,5</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Аниклик тоифаси
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,1,6</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Автоматлаштириш даражаси
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].engineFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2,2 Фойдаланиш тавсифлари
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>2,2,1</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Автоматик, ярим автоматик, ёки ноавтаматик фойдаланилиши
                                      </td>
                                      <td></td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.gearBoxFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.name }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <!--<td align="center"></td>-->
                                      <!--<td align="center">-->
                                      <!--{{autoData.kossApiResponseDto.gearBoxFix.coefficient | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                      <!--</td>-->
                                      <!--<td align="center" v-for="n in 3" :key="n">-->
                                      <!--{{autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.value |-->
                                      <!--currency('', 2, { thousandsSeparator: ' ' })}}-->
                                      <!--</td>-->
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2,2 Фойдаланиш тавсифлари
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        <!--{{autoData.kossApiResponseDto.gearBoxFix.coefficient | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.coefficient | currency('', 2, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,2,2</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Тўхтовсиз ишлаши
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,2,3</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Чидамлилиги
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,2,4</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Таъмирга яроклилиги
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Ярокли
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,2,5</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Бут сакланганлиги
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Бут сакланган
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2,3 Конструктив тавсифлар
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>2,3,1</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Массаси
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].gearBoxFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>2,3,2</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Оғирлиги (Кг)
                                      </td>
                                      <td align="center">Ўлчов бирлиги</td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Килограм
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Оғирлиги</td>
                                      <td align="center">{{ autoData.fullWeight }}</td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].weightFix.value }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].weightFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].weightFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>2,3,3</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Асосий конструктив материалларнинг таркиби
                                      </td>
                                      <td align="center">Позицияси</td>


                                      <td align="center" v-if="autoData.kossApiResponseDto.carPosition>0">
                                        {{ autoData.kossApiResponseDto.carPosition }}
                                      </td>
                                      <td align="center" v-if="autoData.kossApiResponseDto.carPosition==0">
                                        Мавжуд эмас
                                      </td>

                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.name }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Диллерлар томониданталиф килинаётган нарх
                                      </td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.newPriceUzs }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.value }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            2,4 Иқтисодий тавсифлар
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>2,4,1</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Машиналар вакт бирлигида
                                      </td>
                                      <td align="center">Ишлаб чикарилган йили</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.madeYearFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix && autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.name
                                        }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">
                                        Махсулот нархлари киматлашишнинг Статистик индекс
                                      </td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.madeYearFix.value }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.value }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b v-if="autoData.fixByIndex"><i>2,4,2</i></b>
                                        <b v-else><i>2,4,1</i></b>
                                      </td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Махсулот ёки ишлар бирлигида фаолият кўрсатганда турли захиралар
                                        сарфланиши
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b v-if="autoData.fixByIndex">{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].madeYearFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                        <b v-else>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].positionFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3-Боб Киёслаш элементларини танлаш.
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,1 Мулкий ҳуқуқлар
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>3,1,1</i></b></td>
                                      <td align="center" rowspan="3" class="align-middle font-weight-bold">
                                        Сотилганда ўтадиган мулкий ҳуқуқлар
                                      </td>
                                      <td></td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.ownershipFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].ownershipFix.name }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        {{
                                          autoData.kossApiResponseDto.ownershipFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].ownershipFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].ownershipFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,2 Молиялаштириш шартлари
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>3,2,1</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Молиялаштириш шартлари
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Тўлов тури
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Олдиндан тўлов
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        <!--{{autoData.kossApiResponseDto.financeFix.coefficient | currency('', 4, { thousandsSeparator: ' ' })}}-->
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].financeFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].financeFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td v-if="autoData.fixByIndex" colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,3 Бозор холати (Сотиш вакти)
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>3,3,1</i></b></td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Аналог объектларга нархларнинг ўзгариши
                                      </td>
                                      <td align="center">Сотишга таклиф қилинган ёки сотилган сана</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.saleDateFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.name }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">
                                        Махсулот нархлари киматлашишнинг Статистик индекс
                                      </td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.saleDateFix.value }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.value }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        {{
                                          autoData.kossApiResponseDto.saleDateFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr v-if="autoData.fixByIndex">
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>


                                    <tr v-if="!autoData.fixByIndex">
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,3 Бозор холати (Сотиш вакти)
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr v-if="!autoData.fixByIndex">
                                      <td align="center" rowspan="4" style="vertical-align: middle;">
                                        <b><i>3,3,1</i></b></td>
                                      <td align="center" rowspan="4"
                                          style="vertical-align: middle; font-weight: bold">
                                        Аналог объектларга нархларнинг ўзгариши
                                      </td>
                                      <td align="center">Сотишга таклиф қилинган ёки сотилган сана</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.saleDateFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.name
                                        }}
                                      </td>
                                    </tr>
                                    <tr v-if="!autoData.fixByIndex">
                                      <td align="center">
                                        Махсулот нархлари киматлашишнинг Статистик индекс
                                      </td>
                                      <td align="center" style="vertical-align: middle;font-weight: bold">
                                        {{
                                          autoData.kossApiResponseDto.usdRate | currency('', 2, {thousandsSeparator: ' '})
                                        }}
                                        сўм
                                      </td>
                                      <td align="center" style="vertical-align: middle" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.value | currency('', 2, {thousandsSeparator: ' '})
                                        }}
                                        сўм
                                      </td>
                                    </tr>
                                    <tr v-if="!autoData.fixByIndex">
                                      <td align="center">Тузатиш</td>
                                      <td align="center"></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr v-if="!autoData.fixByIndex">
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,4 Сотиш шартлари
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="19" class="align-middle">
                                        <b><i>3,4,1</i></b></td>
                                      <td align="center" rowspan="19" class="align-middle font-weight-bold">
                                        Сотувчи ва харидор ўртасидаги бозорга хос бўлмаган муносабатлар
                                      </td>
                                      <td align="center">Етказиб бершнинг тезлаштирилган муддати</td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b v-if="autoData.fixByIndex">{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                        <b v-else>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Кафолат муддати (йилда)</td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b v-if="autoData.fixByIndex">{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                        <b v-else>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].saleDateCurrencyRateFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center"><b>Чегирмалар</b></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.name
                                          }}</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" class="align-middle"><b>Бутлаш</b></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" class="align-middle"><b>Қўшимча хизматлар</b>
                                      </td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].demandSupply.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="2" class="align-middle"><b>ҚҚС
                                        мавжудлиги</b></td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.vatFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        Мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        {{
                                          autoData.kossApiResponseDto.vatFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                        %
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].vatFix.value | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Тузатиш
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].vatFix.coefficientFix | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].vatFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,5 Физик тавсифлар
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="4" class="align-middle">
                                        <b><i>3,5,1</i></b>
                                      </td>
                                      <td align="center" rowspan="4" class="align-middle font-weight-bold">
                                        Техник холати (Эскириш фоизи)
                                      </td>
                                      <td align="center">Холати</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.conditionFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.name ? autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.name : ''
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">
                                        Эскириш фоизи
                                      </td>
                                      <td align="center">
                                        {{
                                          autoData.kossApiResponseDto.conditionFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                        %
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.value | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                        %
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.conditionFix.value }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>3,5,2</i></b>
                                      </td>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>Жорий фойдаланиш хусусияти</i></b>
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>3,5,3</i></b>
                                      </td>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>Қўшимча бутланиш</i></b>
                                      </td>
                                      <td></td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        Маълумот мавжуд эмас
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center" v-for="n in 4" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].technicalFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colspan="7" align="center">
                                        <b>
                                          <i>
                                            3,6 Фойдаланиш шартлари
                                          </i>
                                        </b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>3,6,1</i></b>
                                      </td>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>Жорий фойдаланиш хусусияти</i></b>
                                      </td>
                                      <td align="center">Ёкилғи тури</td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.fuelTypeFix.name }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.name }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        {{
                                          autoData.kossApiResponseDto.fuelTypeFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{
                                          autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>3,6,2</i></b>
                                      </td>
                                      <td align="center" rowspan="3" class="align-middle">
                                        <b><i>Функцианал фойдаланиш</i></b>
                                      </td>
                                      <td align="center"></td>
                                      <td align="center">
                                        {{ autoData.kossApiResponseDto.autoType }}
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        {{ autoData.kossApiResponseDto.autoDataApiList[n - 1].autoType }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатиш</td>
                                      <td align="center">
                                        1
                                      </td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        1
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="center">Тузатишдан кейинги киймат</td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].fuelTypeFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        Тузатишлар сони
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].totalComparativeFix.fixedCount
                                          }}</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        Коффициент улушлари
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].totalComparativeFix.coefficient | currency('', 4, {thousandsSeparator: ' '})
                                          }}</b>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td align="center" class="align-middle font-weight-bold">
                                        Тузатишларни киритгандан кейинги улушларни хисобга олгандаги бахоси
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td align="center" v-for="n in 3" :key="n">
                                        <b>{{
                                            autoData.kossApiResponseDto.autoDataApiList[n - 1].totalComparativeFix.fixedPrice | currency('', 2, {thousandsSeparator: ' '})
                                          }}
                                          сўм</b>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.auto-cost v-tooltip="'Харажат ёндашув'">
                      <h4>
                        <div class="d-flex">
                          <i class="fa fa-arrow-down"></i>
                          <input type="checkbox" class="ml-2 mr-1"
                                 v-model="autoData.approachOne">
                          {{ $t("auto.approach.expense") }}
                          <b class="ml-4" v-if="autoData.approachOne">
                            <span class="text-success"
                                  v-if="autoData.totalGovPrice">{{
                                autoData.totalGovPrice | currency('', 0, {thousandsSeparator: ' '})
                              }} сўм</span>
                          </b>
                        </div>
                      </h4>
                    </div>
                  </div>
                  <b-collapse id="auto-cost" accordion="evl-accordion" role="tabpanel">
                    <div class="row">
                      <div class="col-12 table-responsive">
                        <div class="card">
                          <div class="table-wrapper">
                            <table class="table">
                              <tbody>
                              <tr>
                                <td class="text-center">
                                  Ишлаб чиқарилган йили
                                </td>
                                <td class="text-center">
                                  {{ autoData.madeYear }}
                                </td>
                              </tr>
                              <tr>
                                <td class="text-center">
                                  Босиб ўтган йўли
                                </td>
                                <td class="text-center">
                                  {{ autoData.overpassKm }} км
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Бохаланаётган машина тўла вазни
                                </td>
                                <td class="text-center">
                                  {{ autoData.fullWeight }} кг
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Турдош машинанинг номи
                                </td>
                                <td class="text-center">
                                  {{ autoData.coincidentalAutoDto.coincidentalName }}
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Турдош машина тўла вазни
                                </td>
                                <td class="text-center">
                                  {{ autoData.coincidentalAutoDto.fullWeight }} кг
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  Чегирма лимити қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.discountLimit }} USD
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  НДС қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.vat }}
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  Божхона ставкаси қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.customs }}
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  Йўл харажатлари қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.road }}
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  Божхона хужжатларини расмийлаштириш харажатлари қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.customsClearance }}
                                </td>
                              </tr>
                              <tr v-if="autoData.foreignCar">
                                <td class="text-center">
                                  Акциз солиқ қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.excise }}
                                </td>
                              </tr>
                              <tr v-if="autoData.priceInCurrency">
                                <td class="text-center">
                                  Валютадаги суммаси
                                </td>
                                <td class="text-center">
                                  {{ autoData.priceInCurrency | currency('', 2, {thousandsSeparator: ' '}) }}
                                  {{ autoData.currency }}
                                </td>
                              </tr>
                              <tr v-if="autoData.priceInCurrency">
                                <td class="text-center">
                                  Валюта курси
                                </td>
                                <td class="text-center">
                                  {{ autoData.currencyRate | currency('', 2, {thousandsSeparator: ' '}) }}
                                  {{ autoData.currency }}
                                </td>
                              </tr>
                              <tr v-if="!autoData.coincidental">
                                <td class="text-center">
                                  Машинанинг тикланиш қийматини суммаси
                                </td>
                                <td class="text-center" v-if="autoData.govPrice>0">
                                  {{ autoData.govPrice | currency('', 2, {thousandsSeparator: ' '}) }} Сум
                                </td>
                                <td class="text-center" v-else>
                                  {{ 0 | currency('', 2, {thousandsSeparator: ' '}) }} Сум
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Турдош машинанинг тикланиш қийматини суммаси
                                </td>
                                <td class="text-center">
                                  {{
                                    autoData.coincidentalAutoDto.coincidentalPrice | currency('', 2, {
                                      thousandsSeparator: ' '
                                    })
                                  }} Сум
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Қўшимча қиймат солиги
                                </td>
                                <td class="text-center">
                                  {{
                                    autoData.coincidentalAutoDto.nds_tax | currency('', 2, {
                                      thousandsSeparator: ' '
                                    })
                                  }}
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Фойда солиги ставкаси
                                </td>
                                <td class="text-center">
                                  {{
                                    autoData.coincidentalAutoDto.npr_tax | currency('', 2, {
                                      thousandsSeparator: ' '
                                    })
                                  }}
                                </td>
                              </tr>
                              <tr v-if="autoData.coincidental">
                                <td class="text-center">
                                  Махсулотнинг рентабиллик курсаткичи
                                </td>
                                <td class="text-center">
                                  {{
                                    autoData.coincidentalAutoDto.profitabilityRatio | currency('', 2, {
                                      thousandsSeparator: ' '
                                    })
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td class="text-center">
                                  Машинанинг эскириш қиймати
                                </td>
                                <td class="text-center">
                                  {{ autoData.dilapidationValue | currency('', 2, {thousandsSeparator: ' '}) }} %
                                </td>
                              </tr>

                              </tbody>
                            </table>
                          </div>

                        </div>
                        <h4 class="card-title text-center"><b>Автотранспортга ўрнатилган газ ускунаси</b></h4>
                        <div class="card">
                          <div class="table-wrapper">
                            <table class="table">
                              <thead>
                              <tr>
                                <th>Қурилма номи</th>
                                <th>Сиғими</th>
                                <th>Сони</th>
                                <th>Фойдаланилган веб-сайт</th>
                                <th>Бахоси (сўм)</th>
                                <th>Эскириш қиймати</th>
                                <th>Қиймати</th>
                              </tr>
                              </thead>
                              <tbody v-if="autoData.autoGasDevice">
                              <tr>
                                <td class="text-center">
                                  {{ autoData.autoGasDevice.name }}
                                </td>
                                <td>
                                  {{ autoData.autoGasDevice.capacity || '' }} л
                                </td>
                                <td>
                                  {{ autoData.autoGasDevice.qty || '' }} дона
                                </td>
                                <td class="text-center">
                                  {{ autoData.autoGasDevice.webSite }}
                                </td>
                                <td class="text-center">
                                  {{ autoData.autoGasDevice.price | currency('', 2, {thousandsSeparator: ' '}) }}
                                </td>
                                <td class="text-center">
                                  {{ autoData.autoGasDevice.dilapidationValue }} %
                                </td>
                                <td class="text-center">
                                  {{ autoData.autoGasDevice.totalPrice | currency('', 2, {thousandsSeparator: ' '}) }}
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="section-header font-weight-bold colllapse-header">
                    <div block v-b-toggle.auto-correction v-tooltip="'Мувофиклаштириш'">
                      <h4>
                        <i class="fa fa-arrow-down"></i>
                        Мувофиклаштириш
                        <b class="ml-4" v-if="autoData.evlPrice">
                          <span
                              class="text-success">{{ autoData.evlPrice | currency('', 0, {thousandsSeparator: ' '}) }} сўм</span>
                        </b>
                      </h4>
                    </div>
                  </div>
                  <b-collapse id="auto-correction" accordion="evl-accordion" role="tabpanel">
                    <div class="row">
                      <div class="col-12 table-responsive">
                        <div class="card">
                          <div class="table-wrapper">
                            <table class="table">
                              <tr>
                                <th class="text-center">Омиллар</th>
                                <th class="text-center" width="20%">Харажат ёндашуви %</th>
                                <th class="text-center" width="20%">Киёсий ёндашуви %</th>
                                <!--<th class="text-center" width="20%">Киёсий ёндашуви %</th>-->
                              </tr>
                              <tr>
                                <td>
                                  <b>Ҳисоблаб топилган кийматлар, Сум</b>
                                </td>
                                <td align="center">
                                  <b>{{ autoData.totalGovPrice | currency('', 0, {thousandsSeparator: ' '}) }} сўм </b>
                                </td>
                                <td align="center">
                                  <b>{{ autoData.avgPrice | currency('', 0, {thousandsSeparator: ' '}) }} сўм </b>
                                </td>
                                <!--<td align="center">-->
                                <!--<b>{{autoData.avgPrice | currency('', 0, { thousandsSeparator: ' ' })}} сўм </b>-->
                                <!--</td>-->
                              </tr>
                              <tr v-for="(correctionType, index) in autoData.correctionTypeDtos"
                                  :key="correctionType.id">
                                <td>
                                  {{ correctionTypeEnum[index][correctionType.correctionType] }}
                                </td>
                                <td class="text-center">
                                                                    <span
                                                                        v-if="correctionType.key!=='SpecificDimensionsApproaches'">
                                                                        {{
                                                                        (correctionType.approachOnePercent / 6).toFixed(2)
                                                                      }} %
                                                                    </span>
                                  <span v-if="correctionType.key==='SpecificDimensionsApproaches'">
                                                                        <b>{{ calculated.totalOne }} %</b>
                                                                    </span>
                                </td>
                                <td class="text-center">
                                                                    <span
                                                                        v-if="correctionType.key!=='SpecificDimensionsApproaches'">
                                                                        {{
                                                                        (correctionType.approachThirdPercent / 6).toFixed(2)
                                                                      }} %
                                                                    </span>
                                  <span v-if="correctionType.key==='SpecificDimensionsApproaches'">
                                                                        <b>{{ calculated.totalThree }} %</b>
                                                                    </span>
                                </td>
                              </tr>
                              <tr v-if="autoData.correctionTypeDtos.length > 0">
                                <td>
                                  <b>Салмоқ бўйича қийматлар суммаси</b>
                                </td>
                                <td align="center">
                                  <b>{{ calculated.totalPriceOne | currency('', 0, {thousandsSeparator: ' '}) }}
                                    сўм</b>
                                </td>
                                <td align="center">
                                  <b>{{ calculated.totalPriceThree | currency('', 0, {thousandsSeparator: ' '}) }}
                                    сўм</b>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Аниқланган қиймати</b>
                                </td>
                                <td align="center" colspan="2">
                                  <b>{{ autoData.evlPrice | currency('', 0, {thousandsSeparator: ' '}) }} сўм </b>
                                </td>
                              </tr>
                            </table>
                          </div>

                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>


            <div class="row mt-5">
              <div class="col-12 btns-box">
                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                  {{ $t("action.cancel") }}
                </button>
                <button class="all-btn add-btn" v-if="canSave" @click="save" :disabled="processing">
                  {{ $t("action.save") }}
                </button>

                <button class="all-btn delete-btn" @click="deleteAuto(auto)"
                        v-if="hasPermission('NEW_AUTO_DELETE')">
                  {{ $t("realEstate.delete.title") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RejectComment/>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import initFilterModel from '@/shared/filter';
import AssetDropZone from '@/views/asset/AssetDropZone'
import {required, requiredUnless} from 'vuelidate/lib/validators';
import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
import FitmentStatusView from '@/views/fitment/FitmentStatusView.vue'
import FitmentHistoryView from '@/views/fitment/FitmentHistoryView.vue'
import RejectComment from '@/components/RejectComment';
import InnerImageZoom from 'vue-inner-image-zoom';
import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
import {VBToggle} from 'bootstrap-vue/es/directives/toggle/toggle'
import {BFormRadioGroup} from 'bootstrap-vue/es/components/form-radio/form-radio-group'
import {BFormGroup} from 'bootstrap-vue/es/components/form-group/form-group'
import {
  AUTO_PART_CONDITIONS,
  AUTO_SALON_PART_CONDITIONS,
  TECHNICAL_CONDITIONS,
  EXIST_NOT_EXIST,
  CORRECTION_TYPE_ENUM
} from '@/shared/constants/auto'

export default {
  name: "auto-plus-add-edit",
  components: {
    AssetDropZone,
    Datepicker,
    PreviewDropZone,
    FitmentStatusView,
    FitmentHistoryView,
    RejectComment,
    BCollapse,
    BFormGroup,
    BFormRadioGroup,
    InnerImageZoom
  },
  directives: {
    'b-toggle': VBToggle
  },
  data() {
    return {
      processing: false,
      loading: {},
      isPageLoadInit: false,
      show: false,
      autoTypeFilter: initFilterModel(),
      technicalConditionOfCars: [],
      dilapidationLookupData: [],
      autoAllPhotos: [],
      texPassportAllPhotos: [],
      autoTypeDtos: [],
      fuelTypes: [],
      selectedRealEstateDocsTab: "images",
      prev: '<i class="material-icons">keyboard_arrow_left</i>',
      next: '<i class="material-icons">keyboard_arrow_right</i>',
      autoPartConditions: AUTO_PART_CONDITIONS,
      evlAutoSaloonPartConditions: AUTO_SALON_PART_CONDITIONS,
      technicalConditions: TECHNICAL_CONDITIONS,
      additionalConveniences: EXIST_NOT_EXIST,
      correctionTypeEnum: CORRECTION_TYPE_ENUM,
      assetItemId: null,
      autoData: {
        id: null,
        assetItemId: null,
        autoGasDevice: {},
        correctionTypeDtos: []
      }
    }
  },
  validations() {
    return {
      autoData: {
        autoTypeDto: {
          required: required
        },
        madeYear: {
          required: required
        },
        governmentNum: {
          required: required
        },
        technicalConditionOfCar: {
          required: required
        },
        dilapidationValueByExpert: {
          required: required
        },
        texPassportNum: {
          required: required
        },
        address: {
          required: required
        },
        overpassKm: {
          required: requiredUnless(() => {
            if (this.autoData.autoTypeDto.typeOfCar === 'SpecialMachinery'
                || this.autoData.autoTypeDto.typeOfCar === 'HalfTrailers'
                || this.autoData.autoTypeDto.typeOfCar === 'Trailers') {
              return true;
            } else {
              return false;
            }
          })
        },
        fuelType: {
          required: requiredUnless(() => {
            if (this.autoData.autoTypeDto.typeOfCar === 'HalfTrailers'
                || this.autoData.autoTypeDto.typeOfCar === 'Trailers') {
              return true;
            } else {
              return false;
            }
          })
        }
      }
    };
  },
  computed: {
    calculated() {
      let differenceOfApproach;
      if (this.autoData.totalGovPrice < this.autoData.avgPrice)
        differenceOfApproach = (1 - (this.autoData.totalGovPrice / this.autoData.avgPrice)).toFixed(4);
      else
        differenceOfApproach = (1 - (this.autoData.avgPrice / this.autoData.totalGovPrice)).toFixed(4);

      return {
        totalOne: differenceOfApproach > 0.3 ? 0.28 : (this.autoData.correctionTypeDtos[6].approachOnePercent / 6).toFixed(2),
        totalThree: differenceOfApproach > 0.3 ? 0.72 : (this.autoData.correctionTypeDtos[6].approachThirdPercent / 6).toFixed(2),
        totalPriceOne: (this.autoData.totalGovPrice * this.autoData.correctionTypeDtos[6].approachOnePercent / 6),
        totalPriceThree: (this.autoData.avgPrice * this.autoData.correctionTypeDtos[6].approachThirdPercent / 6)
      }
    },
    isLoses() {
      return this.autoData.evlGoalType === "Losses";
    },
    canSave() {
      return (!this.autoData.appraisalStatusEnum || this.autoData.appraisalStatusEnum === 'Unreviewed' || this.autoData.appraisalStatusEnum === 'NotFullyEvaluated');
    },
    canEvaluate() {
      return (this.autoData.appraisalStatusEnum === 'Unreviewed');
    },
    canConfirm() {
      return this.autoData.appraisalStatusEnum === 'Rated' && this.hasPermission('NEW_AUTO_CONFIRM');
    },
    canReEvaluate() {
      return (this.autoData.appraisalStatusEnum === 'Rated' || this.autoData.appraisalStatusEnum === 'Confirmed') && this.hasPermission('NEW_AUTO_REEVALUATE');
    },
    canReject() {
      return (this.hasPermission('NEW_AUTO_EDIT') || this.isLoses && this.hasPermission('NEW_AUTO_LOSES_EDIT')) && this.autoData.appraisalStatusEnum === 'Unreviewed' && !this.autoData.hasAppraiserReportEsp;
    },
    hasNotMileage() {
      return this.autoData.autoTypeDto && this.autoData.autoTypeDto.typeOfCar !== 'SpecialMachinery' &&
          this.autoData.autoTypeDto.typeOfCar !== 'HalfTrailers' &&
          this.autoData.autoTypeDto.typeOfCar !== 'Trailers';
    },
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;
      vm.assetItemId = this.$route.params.parentId;

      if (vm.assetItemId && vm.assetItemId > 0) {
        vm.autoData.assetItemId = vm.assetItemId;
      }

      const promises = [];

      if (id && id > 0) {
        vm.isPageLoadInit = true;
        promises.push(this.$http.get('admin/v3/asset/plus/item/auto/' + id));

        Promise.all(promises).then(function (values) {
          if (values.length >= 0) {
            const editData = values[0].data;
            if (!editData.evlGoalType) {
              editData.evlGoalType = '';
            }


            vm.autoData = editData;
            vm.autoData.autoPhotos.forEach((file) => {
              vm.autoAllPhotos.push(file);
            });
            vm.autoData.texPassportFiles.forEach((file) => {
              vm.texPassportAllPhotos.push(file);
            });

            vm.status = editData.appraisalStatusEnum;
            vm.isPageLoadInit = false;
            vm.onChangeTechnicalCondition();
          }
        });
      }
    },

    cancel() {
      this.$router.push('/asset-plus/item/edit/' + this.autoData.assetItemId);
    },
    getTechnicalConditionsOfCar() {
      this.$http.get('/technicalConditionsOfCar').then(response => {
        this.technicalConditionOfCars = response.data;
      }, err => {
        console.log(err)
      });
    },
    onChangeTechnicalCondition() {
      this.dilapidationLookupData = [];

      if (this.autoDto != null && this.autoDto.technicalConditionOfCar != null) {
        const vm = this;
        this.$http.get('/dilapidation-value-expert/' + this.autoDto.technicalConditionOfCar)
            .then(res => {
              vm.dilapidationLookupData = res.data;

            }, err => {
              console.log(err);
            });
      }
    },


    onAutoTypeSearch(searchTxt, loading) {
      loading(true);
      this.autoTypeFilter.search = searchTxt;
      this.searchMethod(loading);
    },
    onAutoTypeFocus() {
      this.autoTypeFilter.search = '';
      this.searchMethod();
    },
    searchMethod(loading) {
      this.autoTypeDtos = [];
      this.$http.post('autoType/searchBy', this.autoTypeFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.autoTypeDtos = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onChangeTechnicalConditionReport() {
      if (this.autoData.technicalConditionReport === "Accessible") {
        this.autoData.electricalComponents = "Accessible";
        this.autoData.steeringMechanisms = "Accessible";
        this.autoData.engine = "Accessible";
        this.autoData.transmissionBox = "Accessible";
        this.autoData.saloonParts = "Accessible";
      }
    },
    getAutoFuelType() {
      this.$http.get('/fuel-type-car').then(response => {
        this.fuelTypes = response.data;
      }, err => {
        console.log(err)
      });
    },
    saveAuto() {

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.processing = true;
      this.$http.post('auto/item/save', this.autoData)
          .then(res => {
            this.processing = false;
            if (res.data.status !== 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t(res.data.message),
                type: 'warning'
              });
              return;
            }
            this.$swal({
              title: this.$t('messages.common.success'),
              text: this.$t('auto.success'),
              type: 'success'
            });
            this.autoData.id = res.data.data;
            this.$router.push('/asset-plus/item/edit/' + this.autoData.assetItemId);
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('auto.error'),
              type: 'error'
            });
            this.processing = false;
          });
    },
    save() {
      this.processing = true;
      this.$http.post('auto/save', this.autoData)
          .then(res => {
            if (res && res.data && res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.auto.statusSuccess'),
                type: 'success'
              });
              this.$router.push('/auto/plus/edit/' + res.data.data.id);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: res.data.message,
                type: 'warning'
              });
            }
            this.processing = false;
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.auto.statusError'),
              type: 'error'
            });
            this.processing = false;
          });
    },

    deleteAuto: function (auto) {
      this.processing = true;
      this.$swal({
        title: this.$t('messages.common.warning'),
        text: this.$t('auto.deleteConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dd3333',
        confirmButtonText: 'Ўчириш',
        cancelButtonText: 'Бекор қилиш'
      }).then((result) => {
        if (result.value) {
          this.$http.delete('delete/appraisal/' + auto.id)
              .then((res) => {
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('auto.deleteSuccess'),
                    type: 'success'
                  });
                  this.cancel()
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: res.data.message,
                    type: 'warning'
                  });
                }
                this.processing = false;
              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('auto.deleteError'),
                  type: 'error'
                });
                this.processing = false;
              });
        } else {
          this.processing = false;
        }
      });
    }

  },
  created() {

    this.init();
    this.getTechnicalConditionsOfCar();
    this.getAutoFuelType();
  }
}
</script>

<style scoped>
.scrollable-div-auto {
  max-height: 700px; /* kerakli balandlik */
  overflow-y: auto; /* vertikal scroll */
  border: 1px solid #ccc; /* optional: ko‘rinishi uchun */
  padding: 10px;
  overflow-x: hidden; /* gorizontal scrollni o‘chiradi */
}
</style>
